export function getInitials(fullName: string) {
  if (!fullName) return '';

  const words = fullName.trim().split(/\s+/);
  const initials = words.slice(0, 2).map((word) => word[0].toUpperCase());

  return initials.join('');
}
